import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import { Tooltip } from "@mui/material";
import { ColDef } from "ag-grid-enterprise";
import type { Duration } from "moment";
import "moment-duration-format";
import { Campaign } from "../models/Campaign";

const moment = getMomentTz();

export const ManualAutoTag = ({
	isManual,
	size = 25,
}: {
	isManual: boolean;
	size?: number;
}) => {
	return (
		<Tooltip title={isManual ? "Manual" : "Automatic"} arrow>
			<div
				style={{
					width: size,
					height: size,
					fontSize: size * 0.56,
					borderRadius: 4,
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					color: "#fff",
					fontWeight: "bold",
					backgroundColor: isManual ? "#4050B5" : "green",
				}}
			>
				{isManual ? "M" : "A"}
			</div>
		</Tooltip>
	);
};

export const useTableData = () => {
	const columnDefs: ColDef[] = [
		// Hide
		{
			field: "ScheduledWeight",
			headerName: "Sched. Weight",
			minWidth: 20,
			flex: 1,
			hide: true,
		},
		{
			field: "ScheduledBillets",
			headerName: "Sched. Bill.",
			minWidth: 20,
			flex: 1,
			hide: true,
		},
		// Visible
		{
			field: "CampaignNumber",
			headerName: "Number",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "SectionName",
			headerName: "Section",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "HeatName",
			headerName: "Heat",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "Start",
			headerName: "Start",
			minWidth: 20,
			flex: 2,
			valueGetter: (params) =>
				dxtToLocalServerTime((params.data as Campaign)?.Start, "MM/dd HH:mm") ||
				"",
		},
		{
			field: "End",
			headerName: "End",
			minWidth: 20,
			flex: 2,
			valueGetter: (params) =>
				dxtToLocalServerTime((params.data as Campaign)?.End, "MM/dd HH:mm") ||
				"-",
		},
		{
			field: "Duration",
			headerName: "Duration",
			minWidth: 20,
			flex: 2,
			valueFormatter: (params) => {
				if (params.value == null) return "";
				if (params.value === 0) return "0m";
				const duration = moment.duration(params.value, "seconds");
				return duration.format("w[w] d[d] h[h] m[m]", { trim: "both" });
			},
		},
		{
			field: "RolledColdTons",
			headerName: "Rolled Tons",
			minWidth: 70,
			flex: 1,
			valueFormatter: (params) => {
				if (params.value) {
					return params.value.toFixed(2);
				}
				return "";
			},
			cellStyle: {
				justifyContent: "flex-end",
			},
		},
		{
			field: "RolledBillets",
			headerName: "Rolled Bill.",
			minWidth: 70,
			flex: 1,
			cellStyle: {
				justifyContent: "flex-end",
			},
		},
		{
			field: "TonsPerHour",
			headerName: "Tons/Hr",
			minWidth: 20,
			flex: 1,
			valueGetter: (params) =>
				(params.data as Campaign)?.TonsPerHour?.toFixed(2),
		},
		{
			field: "TotalDelayTime",
			headerName: "Delays",
			minWidth: 20,
			flex: 2,
			valueFormatter: (params) => {
				if (params.value == null) return "";
				const duration = moment.duration(params.value, "seconds") as Duration;
				return `${duration.format("HH:mm:ss", { trim: false })}`;
			},
		},
		{
			field: "DelayTimePercent",
			headerName: "Delays %",
			minWidth: 20,
			flex: 1,
			valueFormatter: (params) => {
				if (params.value == null) return "";
				return `${(params.data as Campaign).DelayTimePercent?.toFixed(0)}%`;
			},
		},
		{
			field: "Cobbles",
			headerName: "Cobbles",
			minWidth: 20,
			flex: 1,
		},
		// {
		// 	field: "-",
		// 	cellRenderer: GridButtons,
		// 	cellRendererParams: (params: ICellRendererParams) => ({
		// 		setId: setSelectedRowData,
		// 		id: params.data as Campaign,
		// 		edit: false,
		// 		setShowModal: setShowModal,
		// 		showContextMenu: () =>
		// 			showContextMenu(event, params.data, "campaignContext"),
		// 	}),
		// 	wrapText: false,
		// 	autoHeight: false,
		// 	wrapHeaderText: false,
		// 	headerName: "",
		// 	flex: 2,
		// 	maxWidth: 100,
		// 	autoHeaderHeight: true,
		// },
	];
	return { columnDefs };
};
